exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-user-page .overflow{overflow:hidden;text-overflow:ellipsis}.accept-user-page .terms-label .callout{color:#0096d6}.accept-user-page .terms-label:hover{color:#0096d6;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/accept/user/accept-user.scss
// module id = 132
// module chunks = 0